import { EuiFormLabel, EuiComboBox, EuiComboBoxOptionOption } from '@elastic/eui';
import { modelYear } from 'cache';
import { useLocalCache } from 'hooks/useLocalCache';
import { useIntl } from 'react-intl';
import { getRange } from 'utils';

import * as S from './FiltersSidebar.styles';
import { useState } from 'react';

const yearsOptions = getRange({ step: 1, from: new Date().getFullYear() + 1 - 50, size: 50 })
  .map(String)
  .reverse();

export const ModelYearFilter = (): JSX.Element => {
  const [currentYears, setCurrentYears] = useState(yearsOptions);
  const { formatMessage } = useIntl();
  const localFilters = useLocalCache();

  const handleSearchChange = (searchText: string): void => {
    const filtered = yearsOptions
      .map(String)
      .filter((option: string) => option.toLowerCase().includes(searchText.toLowerCase()));

    setCurrentYears(filtered);
  };

  return (
    <EuiComboBox
      async
      placeholder={formatMessage({ id: 'filters.modelYear.placeholder' })}
      options={
        currentYears?.map((x: string) => ({
          label: x,
          value: Number(x),
        })) ?? []
      }
      selectedOptions={localFilters?.data?.modelYear?.map((x: number) => ({
        label: x.toString(),
        value: x,
      }))}
      onSearchChange={handleSearchChange}
      onChange={(x: EuiComboBoxOptionOption<number>[]): void => {
        modelYear(x?.map(({ value }) => value) as number[]);
      }}
    />
  );
};

export const ModelYearFilterSidebar = (): JSX.Element => {
  const { formatMessage } = useIntl();

  return (
    <S.SidebarFilterWrapper>
      <EuiFormLabel>{formatMessage({ id: 'filters.modelYearlabel' })}</EuiFormLabel>
      <ModelYearFilter />
    </S.SidebarFilterWrapper>
  );
};
